import { render } from "./AnalyticCreateComponent.vue?vue&type=template&id=6637f00a"
import script from "./AnalyticCreateComponent.vue?vue&type=script&lang=js"
export * from "./AnalyticCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/analytics/AnalyticCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6637f00a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6637f00a', __exports__)) {
    api.reload('6637f00a', __exports__)
  }
  
  module.hot.accept("./AnalyticCreateComponent.vue?vue&type=template&id=6637f00a", () => {
    api.rerender('6637f00a', render)
  })

}


export default __exports__